import { render, staticRenderFns } from "./ManageChart.vue?vue&type=template&id=063e88b2"
import script from "./ManageChart.vue?vue&type=script&lang=js"
export * from "./ManageChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports